import React, { createElement, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, Modal, Timeline, Progress, Rate, notification, Typography, Image, Card, Skeleton, Form, Input, Comment, Tooltip, Avatar, Popover } from "antd";
import { DislikeOutlined, LikeOutlined, DislikeFilled, LikeFilled } from "@ant-design/icons";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { viewAllCoursesAction } from "../../redux/actions/courseActions";
import Loader from "../../components/common/Loader";
import Helmet from "react-helmet";
import homePicture from "../../assets/images/Pair programming-amico.svg";
import Footer from "../../components/common/Footer";
import MobileFooter from "../../components/common/MobileFooter";
import "../../views/index.css";
import QuotesSection from "./QuotesSection";
import Collaboration from "./card/Collaboration";
import { scroller, Element } from "react-scroll";

const useStyles = makeStyles((theme) => ({
  root: {},
}));
const { Paragraph } = Typography;
const AllCourses = ({ viewAllCoursesAction, courseState }) => {
  const [loading, setLoading] = useState(true);

  const [ellipsis, setEllipsis] = useState(true);
  const classes = useStyles();


  const token = localStorage.getItem("x-auth-token");
  const scrollToCourse = () => {
    scroller.scrollTo('course', {
      duration: 800,
      delay: 100,
      smooth: true
    })
  }

  const getAllCourses = () => {
    viewAllCoursesAction();
  };

  const content = (
    course
  ) => (<div style={{ width: "350px", }}>
    <h1>{course.name}</h1>
    <p style={{ color: "black", fontSize: "smaller" }}>Updated on {new Date(course.updatedAt).toDateString()} </p>


    <p>{course.description}</p>

    <Timeline>
      {course.inspirations.map((insp)=>(
      <Timeline.Item > {insp}</Timeline.Item>))}
      {/* <Timeline.Item color="violet">Solve initial network problems 2015-09-01</Timeline.Item>
      <Timeline.Item color="green">Technical testing 2015-09-01</Timeline.Item> */}
      {/* <Timeline.Item>Network problems being solved 2015-09-01</Timeline.Item> */}
    </Timeline>

    <p style={{ color: "black", fontWeight: "bold", fontSize: "smaller" }}>Prepared by {course.user.firstName} </p>

    <p style={{ color: "black", fontSize: "smaller" }}>Duration: <b>{course.duration} {course.duration < 2 ? "Week" : "Weeks"}</b>  </p>
    Rate: <Rate allowHalf initialValues={5} size="small" /> <br />
    {token ? (<>Progress: <Progress percent={90} steps={5} size="medium" strokeColor="#52c41a" /><br /></>) : (<div style={{ width: "50%" }}></div>)}
    <Link
      to={`/courses/${course.name}`}>
      <Button style={{ marginLeft: "0px" }} >Start Course</Button>

    </Link>
  </div>);

  useEffect(() => {
    getAllCourses();
  }, []);

  const gridStyle = {
    width: "19.5%",
    // width:'500px',
    textAlign: "center",
    background: "red",
    margin: "5px 2px",
    padding: "0px",
    minHeight: "400px",
  };

  useEffect(() => {
    if (courseState.allCoursesData) {
      setLoading(false);
      // uploadImage(courseData.uploaded);
    }
  }, [courseState]);


  const [likes, setLikes] = useState(0);
  const [dislikes, setDislikes] = useState(0);
  const [action, setAction] = useState(null);

  const like = () => {
    setLikes(1);
    setDislikes(0);
    setAction('liked');
  };

  const dislike = () => {
    setLikes(0);
    setDislikes(1);
    setAction('disliked');
  };

  const actions = [
    <Tooltip key="comment-basic-like" title="Like">
      <span onClick={like}>
        {createElement(action === 'liked' ? LikeFilled : LikeOutlined)}
        <span className="comment-action">{likes}</span>
      </span>
    </Tooltip>,
    <Tooltip key="comment-basic-dislike" title="Dislike">
      <span onClick={dislike}>
        {React.createElement(action === 'disliked' ? DislikeFilled : DislikeOutlined)}
        <span className="comment-action">{dislikes}</span>
      </span>
    </Tooltip>
  ];


  return (
    <div className="container">
      <Helmet title="Home" />

      <div className="sectionone">
        <img src={homePicture} alt="home Pic" className="homeImage" />
        <div className="cont-div">
          <h1>Learn Coding With Experts </h1>
          <p style={{ padding: "10px 20px 20px 20px " }}>The world of web development is as wide as the internet itself. Much of our social and vocational lives play out on the internet, which prompts new industries aimed at creating, managing, and debugging the websites and applications that we increasingly rely on. <br />  <br /> We train you through Project-Based.</p>

            <Button size="large" className="mybutton" type="primary" onClick={scrollToCourse}> {token ? "Welcome" : "Get Started"} </Button>
      
        </div>
      </div>

      {token ? (<></>) : (<QuotesSection />)}
      <Element name="course">
        <div className="container-column">
          <div className="container-row container-100 dft-margin-top">

            <div className="body-container" style={{width: "100%"}}>
              <h1 style={{ fontWeight: "bolder" }}>Available courses</h1>
      
              <div className="flex-wrap-row" style={{width:"100%"}}>
                <Skeleton loading={loading} avatar active>
                  {courseState.allCoursesData?.data.map((course, index) => {
                    return (


                      <Popover content={content(course)} placement="right">
                        <Card.Grid key={index} style={gridStyle}   >
                          <Card style={{ height: "100%" }} actions={actions}>


                            <Image
                              preview={false}
                              style={{ width: "100%", height: "200px" }}
                              // src="https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg"
                              src={course.image}
                        
                            />


                            <Link
                              to={`/courses/${course.name}`}

                            >
                              <br />
                              <Skeleton loading={false} avatar active>

                                <h1 style={{
                                  textAlign: "left",
                                  fontSize: "15px",
                                  fontWeight: "bolder",
                                  color: "#038585",
                                }}>{course.name}
                                </h1>
                              </Skeleton>
                                {/* <Paragraph
                              ellipsis={
                                ellipsis
                                  ? {
                                    rows: 2,
                                    expandable: false,
                                    symbol: 'more',
                                  }
                                  : false
                              } style={{ color: "black", textAlign: "left" }}>{course.description}</Paragraph>  */}
                      
                              <p style={{ color: "black", textAlign: "left", fontWeight: "bold", fontSize: "smaller" }}>Prepared by {course.user.firstName} </p>
                              <p style={{ color: "black", textAlign: "left", fontWeight: "medium", fontSize: "smaller" }}>Updated on {new Date(course.updatedAt).toDateString()} </p>

                            </Link>
                          </Card>

                        </Card.Grid>
                      </Popover>
                    );
                  })}




                </Skeleton>
              </div>
            </div>

          </div>
        </div>
      </Element>
      <div>

        <Collaboration />
      </div>
      <Footer />
      <MobileFooter />
    </div>
  );
};

const mapStateToProps = (state) => {
  return { courseState: state.courses.allCourses };
};

const mapDispatchToProps = { viewAllCoursesAction };

export default connect(mapStateToProps, mapDispatchToProps)(AllCourses);
